// extracted by mini-css-extract-plugin
export var root = "_3eOFl";
export var storeButton = "drGTe";
export var tagline = "yeAYG";